import { createNavigationModule } from "../core/createNavigationModule";
import { FULLCARE_NAVIGATION_NODES } from "../registry";
import { universalSearch } from "../search";

const legacyNavigation = createNavigationModule({
  registry: FULLCARE_NAVIGATION_NODES,
  router: { commit() {} },
  preferences: {
    read: () => "v1",
    write() {},
  },
});

const safeLocation = (location) => ({
  pathname: location?.pathname || "/",
  search: location?.search || "",
  state: location?.state || null,
});

/**
 * Projects the shared navigation registry and the Typesense entity index into
 * legacy URLs. Keeping this seam outside Header prevents V1 from growing a
 * second search implementation that could drift from the V2 experience.
 */
export const searchLegacyGlobalNavigation = async ({
  accessKeys,
  locale,
  location,
  query,
  signal,
  userId,
  zooId,
}) => {
  const snapshot = await legacyNavigation.read({
    location: safeLocation(location),
    locale,
    query,
    session: {
      accessKeys,
      rollout: {},
      userId: userId || "anonymous",
    },
  });

  return universalSearch.search({
    accessKeys,
    localResults: snapshot.searchResults,
    query,
    signal,
    version: "v1",
    userId,
    zooId,
  });
};

export default searchLegacyGlobalNavigation;
